import UrlSegment from "./url-segment"

const Constant = { UrlSegment }

export default Constant


// WEBPACK FOOTER //
// ./src/service/sfp/constant/index.ts